import React, { useEffect, useState } from "react";
import { Box, Typography, Link, TextField, Button } from "@mui/material";
import {
  FaFacebookF,
  FaVimeoV,
  FaYoutube,
  FaBitbucket,
  FaPhone,
  FaEnvelope,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom"; // React Router v6의 useNavigate 훅 추가

// 네이버 지도 API 타입 선언
declare global {
  interface Window {
    naver: any;
  }
}

const NAVER_CLIENT_ID = "5cwhpq50um"; // 네이버 지도 API Client ID

const loadNaverMapScript = () => {
  if (document.getElementById("naver-map-script")) return;

  const script = document.createElement("script");
  script.id = "naver-map-script";
  script.src = `https://openapi.map.naver.com/openapi/v3/maps.js?ncpClientId=${NAVER_CLIENT_ID}`;
  script.async = true;
  document.body.appendChild(script);
};

export const SideDrawer = () => {
  const navigate = useNavigate(); // navigate 함수 생성
  
  const [sidebarData, setSidebarData] = useState({
    address: '서울특별시 영등포구 양평동3가 16, 612호',
    phone: '02-2088-7388',
    email: 'che37412@hanmail.net',
    contactTitle: '문의하기',
    latitude: 37.525791,
    longitude: 126.88667,
    companyName: '씨유미디어그룹',
  });

  useEffect(() => {
    // API에서 사이드바 데이터 불러오기
    const loadSidebarData = async () => {
      try {
        const { sidebarApi } = await import('./services/api');
        const data = await sidebarApi.get();
        if (data) {
          setSidebarData(prev => ({
            ...prev,
            contactTitle: data.contactTitle || '문의하기',
            address: data.address || prev.address,
            phone: data.phone || prev.phone,
            email: data.email || prev.email,
            companyName: data.companyName || prev.companyName,
            latitude: data.latitude || prev.latitude,
            longitude: data.longitude || prev.longitude,
          }));
        }
      } catch (error) {
        console.error('사이드바 데이터 로드 실패:', error);
      }
    };

    loadSidebarData();
  }, []);

  useEffect(() => {
    loadNaverMapScript();

    const initMap = () => {
      if (window.naver && window.naver.maps) {
        const map = new window.naver.maps.Map("naver-map-side-drawer", {
          center: new window.naver.maps.LatLng(sidebarData.latitude, sidebarData.longitude),
          zoom: 16,
        });

        const marker = new window.naver.maps.Marker({
          position: new window.naver.maps.LatLng(sidebarData.latitude, sidebarData.longitude),
          map,
        });

        const infoWindow = new window.naver.maps.InfoWindow({
          content: `
            <div style="padding:10px; font-size:14px; color:black;">
              <strong>${sidebarData.companyName}</strong><br/>
              ${sidebarData.address}
            </div>
          `,
        });

        infoWindow.open(map, marker);

        window.naver.maps.Event.addListener(marker, "click", () => {
          if (infoWindow.getMap()) {
            infoWindow.close();
          } else {
            infoWindow.open(map, marker);
          }
        });
      }
    };

    setTimeout(initMap, 500);
  }, [sidebarData.address, sidebarData.latitude, sidebarData.longitude, sidebarData.companyName]);

  return (
    <Box sx={{ width: 300, p: 2 }}>
      {/* 네이버 지도 (오시는 길) */}
      <Box sx={{ mb: 4 }}>
        <Typography
          variant="h6"
          component="h3"
          sx={{
            fontSize: "16px",
            fontWeight: "bold",
            borderBottom: "1px solid #ddd",
            pb: 1,
          }}
        >
          <span>오시는 길</span>
        </Typography>
        <Box sx={{ mt: 2 }}>
          <div
            id="naver-map-side-drawer"
            style={{
              width: "100%",
              height: "200px",
              borderRadius: "8px",
              overflow: "hidden",
            }}
          ></div>
        </Box>
      </Box>

      {/* CONTACT US Section */}
      <Box sx={{ mb: 4 }}>
        <Typography
          variant="h6"
          component="h3"
          sx={{
            fontSize: "16px",
            fontWeight: "bold",
            borderBottom: "1px solid #ddd",
            pb: 1,
          }}
        >
          <span>{sidebarData.contactTitle}</span>
        </Typography>
        <Box sx={{ mt: 2 }}>
          <Typography
            variant="body2"
            sx={{ color: "#666", fontSize: "14px", mb: 1 }}
          >
            {sidebarData.address}
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <FaPhone style={{ marginRight: 8, color: "#333" }} />
            <Typography
              variant="body2"
              sx={{ color: "#333", fontSize: "14px" }}
            >
              {sidebarData.phone}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <FaEnvelope style={{ marginRight: 8, color: "#333" }} />
            <Typography variant="body2" sx={{ fontSize: "14px" }}>
              <Link
                href={`mailto:${sidebarData.email}`}
                sx={{ color: "#333", textDecoration: "none" }}
              >
                {sidebarData.email}
              </Link>
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* 문의하기 Section */}
      <Box>
        <Box component="form" sx={{ mt: 2 }}>
          <Button
            variant="contained"
            color="info"
            sx={{
              backgroundColor: "#333",
              "&:hover": { backgroundColor: "#555" },
            }}
            onClick={() => navigate("/contact")} // 버튼 클릭 시 /contact로 이동
          >
            문의하기
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
